module.exports = __webpack_public_path__ + "img/clear.c09280fd.svg";